<template>
      <b-nav-item-dropdown right no-caret>
        <template slot="button-content">
          <i class="icon-list"></i><b-badge pill variant="warning">{{itemsCount}}</b-badge>
        </template>
        <b-dropdown-header tag="div" class="dropdown-menu-lg text-center"><strong>You have {{itemsCount}} pending tasks</strong></b-dropdown-header>
        <b-dropdown-item>
          <div class="small mb-0">Task One<span class="float-right"></span></div>
        </b-dropdown-item>
        <b-dropdown-item>
          <div class="small mb-0">Task Two<span class="float-right"></span></div>
        </b-dropdown-item>
        <b-dropdown-item>
          <div class="small mb-0">Task Three<span class="float-right"></span>
          </div>
        </b-dropdown-item>
        <b-dropdown-item>
          <div class="small mb-0">Task Four<span class="float-right"></span>
          </div>
        </b-dropdown-item>
        <b-dropdown-item>
          <div class="small mb-0">Task Five<span class="float-right"></span></div>
        </b-dropdown-item>
        <b-dropdown-item class="text-center"><strong>Open Task List</strong></b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
  export default {
    name: 'header-dropdown-tasks',
    data: () => {
      return { itemsCount: 5 }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Header/HeaderDropdownTasks.vue